import {
  faAward,
  faChalkboardTeacher,
  faGraduationCap,
  faSeedling,
  faUserFriends,
} from '@fortawesome/free-solid-svg-icons';
import {
  faCompass as faCompassRegular,
  faHandPointer as faHandPointerRegular,
} from '@fortawesome/free-regular-svg-icons';

import heroBackground from '@src/home/assets/jiltarjih/background.jpg';
import heroVideoThumbnail from '@src/home/assets/jiltarjih/video/homepage-hero-video-thumb.jpg';
import almaaliLogo from '@src/home/assets/jiltarjih/partners/almaali.png';
import elbassiraLogo from '@src/home/assets/jiltarjih/partners/elbassira.png';
import kualaLumpurForumLogo from '@src/home/assets/jiltarjih/partners/kualalumpur-forum.png';
import ltaLogo from '@src/home/assets/jiltarjih/partners/lta.png';
import nbquranLogo from '@src/home/assets/jiltarjih/partners/nbquran.png';
import roshdLogo from '@src/home/assets/jiltarjih/partners/roshd.png';
import thurayaLogo from '@src/home/assets/jiltarjih/partners/thuraya.png';
import cheikhAhmedBoussag from '@src/home/assets/jiltarjih/testimonials/cheikh-ahmed-boussag.jpg';
import drAhmadNawfal from '@src/home/assets/jiltarjih/testimonials/dr-ahmad-nawfal.jpg';
import drMuneerGhadban from '@src/home/assets/jiltarjih/testimonials/dr-muneer-ghadban.jpg';
import drTareqSuwaidan from '@src/home/assets/jiltarjih/testimonials/dr-tareq-al-suwaidan.jpg';

import messages from './messages';

export const heroContent = {
  background: heroBackground,
  videoThumbnail: heroVideoThumbnail,
  title: messages.heroTitle,
  lead: messages.heroLead,
  searchPlaceholder: messages.heroSearchPlaceholder,
};

export const stepItems = [
  {
    title: messages.stepChooseTitle,
    text: messages.stepChooseText,
    icon: faHandPointerRegular,
  },
  {
    title: messages.stepPaceTitle,
    text: messages.stepPaceText,
    icon: faCompassRegular,
  },
  {
    title: messages.stepCertificateTitle,
    text: messages.stepCertificateText,
    icon: faAward,
  },
] as const;

export const serviceItems = [
  {
    title: messages.serviceKnowledgeTitle,
    text: messages.serviceKnowledgeText,
    icon: faGraduationCap,
  },
  {
    title: messages.serviceEducationTitle,
    text: messages.serviceEducationText,
    icon: faUserFriends,
  },
  {
    title: messages.serviceTrainingTitle,
    text: messages.serviceTrainingText,
    icon: faChalkboardTeacher,
  },
  {
    title: messages.serviceProjectsTitle,
    text: messages.serviceProjectsText,
    icon: faSeedling,
  },
] as const;

export const partnerItems = [
  { title: messages.partnerLta, image: ltaLogo, href: 'https://leadersta.com' },
  { title: messages.partnerNbquran, image: nbquranLogo, href: 'https://nbquran.com' },
  { title: messages.partnerAlmaali, image: almaaliLogo, href: 'https://facebook.com/AlmaaliDZ' },
  { title: messages.partnerRoshd, image: roshdLogo, href: 'https://web.facebook.com/Rusheddz' },
  { title: messages.partnerElbassira, image: elbassiraLogo, href: 'https://www.elbassira.org/' },
  { title: messages.partnerKlForum, image: kualaLumpurForumLogo, href: 'https://kl-forum.org' },
  { title: messages.partnerThuraya, image: thurayaLogo, href: 'https://thuraya-arts.net' },
] as const;

export const testimonialItems = [
  {
    name: messages.testimonialTareqName,
    role: messages.testimonialTareqRole,
    text: messages.testimonialTareqText,
    image: drTareqSuwaidan,
  },
  {
    name: messages.testimonialNawfalName,
    role: messages.testimonialNawfalRole,
    text: messages.testimonialNawfalText,
    image: drAhmadNawfal,
  },
  {
    name: messages.testimonialGhadbanName,
    role: messages.testimonialGhadbanRole,
    text: messages.testimonialGhadbanText,
    image: drMuneerGhadban,
  },
  {
    name: messages.testimonialBoussagName,
    role: messages.testimonialBoussagRole,
    text: messages.testimonialBoussagText,
    image: cheikhAhmedBoussag,
  },
] as const;
